<template>
  <qx-card-form title="备注">
    <qx-custom-form :noSubBtn="true"
                    ref="baseForm"
                    :formData="baseForm"
                    labelWidth="120px">
      <section slot="split"></section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  isExist,
} from '@qx/utils/index';
export default {
  data () {
    return {
      idsInfo: {
        orderId: '',
        orderInfoId: '',
        orderInfoExtId: '',
        orderFeeId: '',
        orderFeeExtId: '',
        orderGoodsId: '',
        orderSchedulerId: '',
      },
      otherFormData: {
        oldUpdateType: null,
        updateType: null,
        dispatch: 0,
      },
      otherData: {},
      baseForm: {
        orgIdOptions: [],
        inline: true,
        form: [
          {
            label: '备注说明',
            value: 'remarks',
            placeholder: '请输入备注说明',
            type: 'input',
            width: '610px',
            attr: {
              type: 'textarea',
              limit: 300,
            },
          },
        ],
      },
    };
  },
  methods: {

    async sub () {
      let formData = await this.handleSubData();
      // 提交的时候把 一大堆需要提交的 ID 丢上去，之所以放在这里，是因为这里代码少
      if (this.$route.query.id && formData.idsInfo && Object.keys(formData.idsInfo).length) {
        let idsInfo = {};
        let otherData = {};
        for (let name in formData.idsInfo) {
          if (name) {
            idsInfo[`ids.${name}`] = formData.idsInfo[name];
          }
        }
        for (let name in formData.otherData) {
          if (name) {
            otherData[`otherData.${name}`] = formData.otherData[name];
          }
        }
        // 补充一些不知道是什么又不得不加的参数
        formData = {
          ...idsInfo,
          ...otherData,
          ['dispatchInfo.preAmountFlag']: otherData.preAmountFlag,
          ...this.otherFormData,
          remarks: formData.remarks,
        };
      } else {
        delete formData.idsInfo;
        delete formData.otherData;
        delete formData.otherFormData;
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      formData = {
        idsInfo: this.idsInfo,
        otherFormData: this.otherFormData,
        otherData: this.otherData,
        remarks: formData.remarks,
      };
      return formData;
    },
    setDetailData (data) {
      this.idsInfo.orderId = this.$route.query.id;
      if (data.orderInfo) {
        this.idsInfo.orderInfoId = data.orderInfo ? data.orderInfo.id : '';
        this.otherData.opOrgId = data.orderInfo ? data.orderInfo.opOrgId : '';
      }
      if (data.orderInfoExt) {
        this.idsInfo.orderInfoExtId = data.orderInfoExt ? data.orderInfoExt.id : '';
        this.otherData.preAmountFlag = data.orderInfoExt ? data.orderInfoExt.preAmountFlag : '';
      }

      if (data.orderFee) {
        this.idsInfo.orderFeeId = data.orderFee ? data.orderFee.id : '';
        this.otherData.finalFeeFlag = data.orderFee ? data.orderFee.finalFeeFlag : '';
        this.otherData.payoutStatus = data.orderFee ? data.orderFee.payoutStatus : '';
        this.otherData.verificationState = data.orderFee ? data.orderFee.verificationState : '';
        this.otherData.vehicleAffiliation = data.orderFee ? data.orderFee.vehicleAffiliation : '';
      }

      if (data.orderFeeExt) {
        this.idsInfo.orderFeeExtId = data.orderFeeExt ? data.orderFeeExt.id : '';
      }

      if (data.orderGoods) {
        this.idsInfo.orderGoodsId = data.orderGoods ? data.orderGoods.id : '';
        this.otherData.reciveState = data.orderGoods ? data.orderGoods.reciveState : '';
        this.otherData.loadState = data.orderGoods ? data.orderGoods.loadState : '';
      }

      if (data.orderScheduler) {
        this.idsInfo.orderSchedulerId = data.orderScheduler ? data.orderScheduler.id : '';
      }

      if (this.$route.query.id) {
        // 修改订单
        const oldUpdateType = data.updateType;

        if (isExist(data.updateType) && (data.orderInfo.orderState >= 7)) {
          this.otherFormData.updateType = data.updateType;
        } else if (data.orderInfo.orderState >= 1 && data.orderInfo.orderState <= 4) {
          this.otherFormData.updateType = '1';
        } else if (data.orderInfo.orderState < 7 && data.updateType >= 3) {
          this.otherFormData.updateType = '5';
        } else if (!isExist(data.updateType)) {
          this.otherFormData.updateType = '0';
        }

        // 调度
        if (oldUpdateType !== null && oldUpdateType > 0 && data.orderInfo.orderState < 7) {
          this.otherFormData.dispatch = '1';
        }

      } else {
        // 新增
        this.otherFormData.updateType = null;
        this.otherFormData.dispatch = '0';
      }
    },
    async init (data = {}) {
      this.setDetailData(data);
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
